/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class SubjectImage implements Serializable<SubjectImage> {
    id: number;
    image: string;
    thumbnail: string;
    photo: any;
    deleted: boolean;
    sortOrder: number;
    isNewlyAdded: boolean;
    addedBy: number;
    createdDate: string;
    subjectId: number;
    new: boolean;

    deserialize(input: any) {
        input.id && (this.id = input.id);
        input.addedBy && (this.addedBy = input.addedBy);
        input.photo && (this.image = input.photo);
        input.thumbnail && (this.thumbnail = input.thumbnail);
        input.sortOrder && (this.sortOrder = input.sortOrder);
        input.createdDate && (this.createdDate = input.createdDate);
        this.deleted = input.deleted || false;
        this.isNewlyAdded = input.isNewlyAdded || false;
        input.subjectId && (this.subjectId = input.subjectId);

        return this;
    }

    constructor() {
    }
}
